import { render } from "./LoadingDefault.vue?vue&type=template&id=9a13213c&scoped=true&ts=true"
import script from "./LoadingDefault.vue?vue&type=script&lang=ts"
export * from "./LoadingDefault.vue?vue&type=script&lang=ts"

import "./LoadingDefault.vue?vue&type=style&index=0&id=9a13213c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a13213c"]])

export default __exports__